import React, { ReactElement } from 'react'
import styled from 'styled-components'
import {
  AsyncButton,
  ButtonStyle,
  InputGroup,
  InputField,
  InputType,
  capitalize,
} from '@one-tree/library'
import CardContent from '../../components/page/CardContent'
import CardHeader from '../../components/page/CardHeader'
import { useOrganisation } from '../../context/OrganisationProvider'
import { voucherWord } from '../../helpers/FormatHelper'
import { StateAction } from '../../types/Aliases'
import useResponsive from '../../helpers/isResponsive'
import CodeInput from '../../components/fields/codeField/CodeInput'

const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
`
const StyledInputGroup = styled(InputGroup)`
  display: flex;
  align-items: flex-end;
  gap: 10px;
  flex: auto;
  justify-content: space-between;
  ${(props): string => props.theme.isMobile
    && 'flex-direction: column; row-gap: 10px; align-items: flex-start !important;'}
`
const CollapsibleContent = styled.div`
  padding-top: 12px;
`
const AlternativeText = styled.p`
  font-size: 0.95rem;
  font-style: italic;
  color: ${(props): string => props.theme.colourBodyText || '#666'};
  margin: 20px 0;
  padding-top: 10px;
`
const CollapsibleForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`
const VoucherIdInputWrapper = styled.div`
  flex: 2;
  min-width: 0;
`
const ButtonWrapper = styled.div`
  display: flex;
  flex: auto;
  justify-content: flex-end;
  margin-left: auto;
  flex-shrink: 0;
  align-self: flex-end;
`

interface RedeemerSearchProps {
  voucherId: string
  setVoucherId: StateAction<string>
  voucherCode: string
  setVoucherCode: StateAction<string>
  searchGiftCard: () => void
}

function RedeemerSearch(props: RedeemerSearchProps): ReactElement {
  const {
    voucherId,
    setVoucherId,
    voucherCode,
    setVoucherCode,
    searchGiftCard,
  } = props
  const { organisation } = useOrganisation()

  return (
    <StyledCard>
      <CardHeader title={`Redeem a ${voucherWord(organisation)}`} />
      <CardContent>
        <p>
          Enter the unique 16 character code. The code includes the letters A-F
          and numbers 0-9. It is not case-sensitive.
        </p>
        <form onSubmit={(event): void => event.preventDefault()}>
          <StyledInputGroup theme={useResponsive()}>
            <CodeInput value={voucherCode} onChange={setVoucherCode} />
            <AsyncButton
              buttonStyle={ButtonStyle.Primary}
              onClick={searchGiftCard}
            >
              Check validity
            </AsyncButton>
          </StyledInputGroup>
          <AlternativeText>
            Alternatively, if the customer doesn&apos;t have the 16 character code
            you can search for the gift voucher with the 6 digit Gift Voucher ID below.
          </AlternativeText>
          <CollapsibleContent>
            <CollapsibleForm>
              <StyledInputGroup theme={useResponsive()}>
                <VoucherIdInputWrapper theme={useResponsive()}>
                  <InputField
                    type={InputType.Text}
                    label={`${capitalize(voucherWord(organisation))} ID`}
                    value={voucherId}
                    onChange={setVoucherId}
                  />
                </VoucherIdInputWrapper>
                <ButtonWrapper>
                  <AsyncButton
                    buttonStyle={ButtonStyle.Primary}
                    onClick={searchGiftCard}
                  >
                    Check validity
                  </AsyncButton>
                </ButtonWrapper>
              </StyledInputGroup>
            </CollapsibleForm>
          </CollapsibleContent>
        </form>
      </CardContent>
    </StyledCard>
  )
}
export default RedeemerSearch
